<template name = "dateTemplate" lang="html">
	<div class="row">
		<div class="content content-components">
			<div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
				<div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
					<div>
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb breadcrumb-style1 mg-b-10">
								<li class="breadcrumb-item">{{this.mainName}}</li>
								<li class="breadcrumb-item active" aria-current="page">{{this.subName}}</li>
							</ol>
							<h4 class="mg-b-0 tx-spacing--1">{{this.subName}}</h4>
						</nav>
					</div>
					<div class="card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end">
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" v-on:click="createData()"><feather type="folder" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Save</button>
					</div>
				</div>
				<div class=" pd-x-0 pd-lg-x-10 pd-xl-x-0">
					<div class="row row-xs">
						<div class="col-sm-6 col-lg-1 p-0">
							<div class="card card-body p-2">
								<b-menu :accordion="false">
									<b-menu-list label="Company">
										<b-menu-item :expanded="true" v-for="form in companyData" :key="form.id" :label="form[companyNameCode]" :id="form.id" @click="selectEvent(1, form.id, form[companyNameCode])" icon="briefcase" class="tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1"></b-menu-item>
									</b-menu-list>
								</b-menu>
							</div>
						</div>
						<div class="col-sm-6 col-lg-2 p-0">
							<div class="card card-body p-2">
								<div class="col-sm-6 col-lg-12 p-0">
									<b-menu :accordion="false">
										<b-menu-list label="Menu">
											<b-menu-item :expanded="true" :disabled="true" v-for="form in menuDepth" :key="form.id" :label="form.menuName" :id="form.id" icon="folder-multiple-outline" class="tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1">
												<div v-for="child in form.child" :key="child.id" :id="child.id" class="tx-12 tx-uppercase tx-medium tx-sans tx-spacing-1">
													<b-menu-item @click="selectEvent(2, child.id, child.menuName)" icon="folder-outline" class="display-inline-block">
														<template slot="label" slot-scope="props">
															{{child.menuName}}
														</template>
													</b-menu-item>
													<b-dropdown aria-role="list" class="top-rem" v-if="isNull(child.menuAbbr)">
														<b-icon icon="dots-vertical" size="is-small" slot="trigger" class="tx-8 clearfix"></b-icon>
														<b-dropdown-item aria-role="listitem" class="tx-10" @click='addJob(child.id, child.menuName)'>작업순서추가</b-dropdown-item>
													</b-dropdown>
												</div>
											</b-menu-item>
										</b-menu-list>
									</b-menu>
								</div><!-- col -->
							</div>
						</div>
						<div class="col-sm-6 col-lg-9 p-0">
							<div class="card card-body p-2">
								<div class="d-md-block tx-right-f col-sm-6 col-lg-12 p-0">
									<a href="" class="d-inline-flex mb-0 ml-2" data-toggle="modal" data-animation="effect-flip-horizontal" @click="initialize()"><feather type="rotate-cw" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather></a>
								</div>
								<div class="col-sm-6 col-lg-12 p-0 menu-label"><span class="fs-rem75 mr-5">sheet list</span>
									<b-tag type="is-primary" attached aria-close-label="Close tag" class='d-inline-flex mb-0 ml-2' v-for="form in selectData" :key="form.id">{{form.idx}}. {{form.name}}</b-tag>
								</div><!-- col -->
								<div class="col-sm-6 col-lg-12 p-0">
									<div class="card card-body">
										<div class="list-group overflow-auto">
											<div class="list-group-item bd-0-f mb-0 pl-1 pr-0" v-for="(form, i) in listSheetData">
												<span class="list-group-item input-group-append fl" v-if="form.linkMenu"><feather type="check-square" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather></span>
												<span class="list-group-item input-group-append pb-2 fl" v-else><b-checkbox :value="form" v-model="checkList" v-bind:true-value="i" @click.native="checked(i, form, 'list')"></b-checkbox></span>
												<span class="list-group-item input-group-append fl">{{Number(i)+1}}</span>
												<span class="list-group-item input-group-append fl">{{form.sheetcode}}</span>
												<span class="list-group-item input-group-append fl">{{form.createdate}}</span>
												<div class="list-group d-webkit-box">
													<span class="list-group-item input-group-append pb-2" v-for="(form1, j) in form.columns">{{form1.columnName}}</span>
													<a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase mg-y-4 mg-l-3-f" v-if="form.linkMenu"  @click="linkDelete(form, i, 'list')" data-toggle="modal" data-animation="effect-flip-horizontal">
														<feather type="trash-2" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
													</a>
												</div>
											</div>
										</div>
									</div>
								</div><!-- col -->
								<div class="col-sm-6 col-lg-12 p-0 menu-label fs-rem75">sheet detail</div><!-- col -->
								<div class="col-sm-6 col-lg-12 p-0">
									<div class="card card-body">
										<div class="list-group overflow-auto">
											<div class="list-group-item bd-0-f mb-0 pl-1 pr-0" v-for="(form, i) in detailSheetData">
												<span class="list-group-item input-group-append fl" v-if="form.linkMenu"><feather type="check-square" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather></span>
												<span class="list-group-item input-group-append pb-2 fl" v-else><b-checkbox :value="form" v-model="checkDetail" v-bind:true-value="i" @click.native="checked(i, form, 'detail')"></b-checkbox></span>
												<span class="list-group-item input-group-append fl">{{Number(i)+1}}</span>
												<span class="list-group-item input-group-append fl">{{form.sheetcode}}</span>
												<span class="list-group-item input-group-append fl">{{form.createdate}}</span>
												<div class="list-group d-webkit-box">
													<span class="list-group-item input-group-append" v-for="(form1, j) in form.columns">{{form1.columnName}}</span>
													<a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase mg-y-4 mg-l-3-f" v-if="form.linkMenu"  @click="linkDelete(form, i, 'detail')" data-toggle="modal" data-animation="effect-flip-horizontal">
														<feather type="trash-2" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
													</a>
												</div>
											</div>
										</div>
									</div>
								</div><!-- col -->
							</div>
							<div class="card card-body p-2 mt-1">
								<div class="col-sm-6 col-lg-12 p-0 menu-label fs-rem75">job order</div><!-- col -->
								<div class="col-sm-6 col-lg-12 p-0">
									<div class="card card-body">
										<draggable class="list-group d-webkit-box" :list="menuSheetLinkData" :group="'joborder'" @change="log">
											<span class="list-group-item input-group-append" v-for="(form, i) in menuSheetLinkData">{{Number(i)+1 +'. '+ form.menuName}}
												<a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="menuSheetlinkDelete(form.id, i)">
													<feather type="trash-2" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
												</a>
											</span>
										</draggable>
									</div>
								</div><!-- col -->
							</div>
						</div>
					</div><!-- row row-xs -->
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import common from '@/views/Common/common.js';
	import {bus} from '../../../main';
	// vue draggable api import
	import draggable from "vuedraggable";
	
	import { Buefy } from 'buefy';

	export default {
		name: 'Authority',
		props: ['properties'],
		components: {
			draggable,
		},
		computed: {},
		data() {
			return {
				mainName:'',
				subName:'',
				menuData:[], // header.vue data
				companyData: [],
				companyNameCode: [],
				menuAll: [],
				menuDepth: [],
				selectData: [],
				listSheetData: [],
				detailSheetData: [],
				menuSheetLinkData: [],
				nomalMenuLink: [],
				thisCompanyId: '',
				
				checkList: false,
				checkDetail : false,
				checkListData: {},
				checkDetatilData: {},

				delListLink: '',
				delDetailLink: '',

				jobFlag: false,
				jobOrders: [],
			}
		},
		beforeDestroy(){
			bus.$off('menu_data');
		},
		created() {
			bus.$on('menu_data', (data)=>{
				this.menuData = data;
				this.classifyAuthority();
				this.classifyCompany();
				this.classifyMenu();

			});
		},
		mounted() {},
		methods: {
			/*
			* Load Data Reception Headers
			*/
			async classifyAuthority(){
				let data = common.menuHeader(this.properties.mid, this.menuData);
				this.mainName = data[0];
				this.subName = data[1];
				this.companyHeader = data[3];
			},
			/*
			* Load Data Company
			*/
			async classifyCompany(){
				let menuid = common.menuidSearch(this.menuData, 'companies')
				let companyHeader = common.menuHeader(menuid, this.menuData)[3];
				this.companyNameCode = common.find_last_column(companyHeader, 'companyname');
				var params = { mid: menuid };
				var request = { params: params };
				await this.$axios.get(this.$apiHost + "/companies/search", request)
				.then(res => {
					this.companyData = res.data
				})
				.catch(error => {throw error;});
			},
			/*
			* Load Data Menu
			*/
			async classifyMenu(){
				await this.$axios.get(this.$apiHost + "/menus")
				.then(res => {
					this.menuAll = res.data
				})
				.catch(error => {throw error;});
				this.menuAll.sort((a, b)=>{
					if(a.menuDepth > b.menuDepth) return 1;
					else if(a.menuDepth < b.menuDepth) return -1;
					else if(a.menuSort > b.menuSort) return 1;
					else if(a.menuSort < b.menuSort) return -1;
					return 0
					}); // 정렬 이후 make data
				this.menuAll.forEach((a,b)=>{
					if(a.menuDepth == 1){
						a.child = [];
						this.menuDepth.push(a)
					}else if(a.menuDepth == 2){
						this.menuDepth.forEach((b, c)=>{
							if(a.parentId === b.id) b.child.push(a);
							b.child.sort((e, f)=>{return e.menuSort - f.menuSort;});
						});
					}else if (a.menuDepth == 3){
					}
				});
			},
			/*
			* company, menu select event
			*/
			async selectEvent(idx, id, name){
				let spid = ''
				if(this.selectData.length > 0){
					this.selectData.some((a,b)=>{
						if(idx == a.idx){
							spid = a.id
							this.selectData.splice(b, 1);
							return true
						}
					});
					if(id != spid){
						this.selectData.push({idx: idx, id: id, name: name});
						this.selectData.sort((a, b)=>{return a.idx - b.idx;});
					}
				}else{
					this.selectData.push({idx: idx, id: id, name: name});
				}
				if(idx == 1){
					this.menuSheetLinkData = []
					if(id != spid){
						var params = [];
						params = {companyId: id};
						var request = {params : params}
						await this.$axios.get(this.$apiHost + '/menusheetlinks/companies', request)
						.then(res=>{
							res.data.job.forEach(a=>{
								a.menuName = '';
							});
							this.menuSheetLinkData = res.data.job;
					   
							for(let i in this.menuSheetLinkData) {
								if (this.menuSheetLinkData[i].jobOrder === 9999) { //orderconfirmation은 아예 못바꾸게
									this.menuSheetLinkData.splice(i, 1);
								}
							}
							this.nomalMenuLink = res.data.nomal;
						}).catch(err=>{console.log(err)});
						this.menuSheetLinkData.sort((a,b)=>{return a.jobOrder - b.jobOrder;});
						this.menuSheetLinkData.forEach(a=>{
							this.menuAll.some(b=>{
								if(a.menuId == b.id){
									a.menuName = b.menuName; 
									return true;
								}
							});
						});
						this.selectData.some(a=>{
							this.thisCompanyId = a.id
						});
					}
				}else if (idx == 2){
					this.listSheetData = [];
					this.detailSheetData = [];
					var params = [];
					if(id != spid){
						params = {'mid' : id, 'gubun' : 'list'};
						var request = {params : params}
						await this.$axios.get(this.$apiHost + '/sheets/all', request)
						.then(res=>{
							res.data.forEach(a=>{a.linkMenu = false});
							this.listSheetData = res.data;
						}).catch(err=>{console.log(err)});
						params = [];
						params = {'mid' : id, 'gubun' : 'detail'};
						var request = {params : params}
						await this.$axios.get(this.$apiHost + '/sheets/all', request)
						.then(res=>{
							res.data.forEach(a=>{a.linkMenu = false});
							this.detailSheetData = res.data;
						}).catch(err=>{console.log(err)});
					}
					
				}

				// sheet list, detail에 link가 있는 데이터의 체크박스를 처리한다.
				if(this.selectData.length == 2) {
					this.nomalMenuLink.forEach(a=>{
						if(this.listSheetData.length > 0){
							this.listSheetData.some(b=>{
								if(a.sheetId == b.sheetid){
									b.linkMenu = true;
									return true;
								}
							});
						}
						if(this.detailSheetData.length > 0){
							this.detailSheetData.some(b=>{
								if(a.detailSheetid == b.sheetid){
									b.linkMenu = true;
									return true;
								}
							});
						}
					});
				}

			},
			/*
			* Add Job Order
			*/
			async addJob(id, name){
				if (this.selectData.length != 2) {
					this.$buefy.dialog.alert({
						message: 'You have to select both company and menu',
						size: 'is-medium',
						type: 'is-danger'
					});
					return false;
				}
				let boolMenu = false
				this.menuSheetLinkData.some(a=>{
					if(id ===a.menuId){
						boolMenu = true;
						return true;
					} 
				});
				if(!boolMenu) this.menuSheetLinkData.push({companyId: this.thisCompanyId, menuId: id, menuName: name})
			},
			async createData() {
				try {
					 this.$buefy.dialog.confirm({
						message: "Do you want to save the changes?",
						size: 'is-medium',
						onConfirm: async () => {
							let params = {}
							// console.log(this.selectData)//idx:1은 company uid 회사 2는 menu uid
							if (this.selectData.length == 0) {
								this.$buefy.dialog.alert({
									message: 'Please select a company and menu',
									size: 'is-medium',
									type: 'is-danger'
								});
							   return false;
							} else if(this.selectData.length == 1) {
								for (let i in this.selectData) {
									if (this.selectData[i].idx != 1) {
										this.$buefy.dialog.alert({
											message: 'Please select a company',
											size: 'is-medium',
											type: 'is-danger'
										});
										return false;
									}
									if (this.selectData[i].idx != 2) {
										this.$buefy.dialog.alert({
											message: 'Please select a menu',
											size: 'is-medium',
											type: 'is-danger'
										});
										return false;
									}
								}
							}

							params.companyId = this.selectData[0].id;
							params.menuId = this.selectData[1].id;
							params.addList = this.checkListData.sheetid; //잡오더 가공 필요
							params.addDetail = this.checkDetatilData.sheetid; //잡오더 가공 필요 , 기존 list데이터에 detailsheetid업데이트
							params.delListLink = this.delListLink;
							params.delDetailLink = this.delDetailLink;
							if (this.jobFlag) {
								let count = 0;
								let id = '';
								for (let i in this.listSheetData) {
									if (this.listSheetData[i].linkMenu) {
										id = this.findLink(this.listSheetData[i].sheetid).id;
										for (let j in this.menuSheetLinkData) {
											if (!this.menuSheetLinkData[j].id) {
												this.menuSheetLinkData[j].id = id
											}
										}
										count ++;
									}
								}

								if (count != 0 || params.addList) {
									params.jobOrders = this.menuSheetLinkData;
								} else {
									this.$buefy.dialog.alert({
										message: 'Please select a list',
										size: 'is-medium',
										type: 'is-danger'
									});
									return false;
								}
							}


							if (typeof this.checkList == 'number') {
								for (let i in this.listSheetData) {
									if (this.listSheetData[i].linkMenu) {
										params.changeList = this.listSheetData[i].sheetid;
									} else {
										if (!params.addList && params.addDetail) {
											this.$buefy.dialog.alert({
												message: 'Please select a list',
												size: 'is-medium',
												type: 'is-danger'
											});
											return false;
										} 
									}
								}
							} 
							if (typeof this.checkDetail == 'number') {
								for (let i in this.detailSheetData) {
									if (this.detailSheetData[i].linkMenu) {
										params.changeDetail = this.detailSheetData[i].sheetid;
									} 
								}
							} 
							if (params.changeList) {
								params.linkId = this.findLink(params.changeList).id;
							}

							const create = await this.$axios.post(this.$apiHost + '/menusheetlinks', params);

							if (create.status == 200){
								this.initialize();
								this.$buefy.dialog.alert({
									message: create.data.msg,
									size: 'is-medium',
								});
		
								return false;
							}
						}
					});
				} catch (error) {
					console.log(error)

				}
			},
			checked(idx, form, gubun) {
				if (gubun === 'list') {
					this.checkListData = {};
					if (typeof this.checkDetail == 'boolean') {
						this.checkListData = form;
					} else {
						this.checkListData = {};
					}
				} else {
					this.checkDetatilData = {};
					if (typeof this.checkDetail == 'boolean') {
						this.checkDetatilData = form;
					} else {
						this.checkDetatilData = {};
					}
				}
				console.log(this.checkListData);
			},
			log(evt) {
				for (let i in this.menuSheetLinkData) {
					this.menuSheetLinkData[i].jobOrder = Number(i) + 1;
				}
			},
			findLink(sheetId) {
				let id = this.nomalMenuLink.filter(item => {
					if (item.companyId == this.selectData[0].id && 
						item.menuId == this.selectData[1].id &&
						item.sheetId == sheetId) {
						return item.id
					}
				});

				return id[0];
			},
			findLinkByDetail(detailSheetId) {
				let id = this.nomalMenuLink.filter(item => {
					if (item.companyId == this.selectData[0].id && 
						item.menuId == this.selectData[1].id &&
						item.detailSheetid == detailSheetId) {
						return item.id
					}
				});

				return id[0];
			},
			linkDelete(form, idx, gubun) {
				if (gubun == 'list') {
					this.listSheetData[idx].linkMenu = false;
					this.jobFlag = false;
					this.delListLink = this.findLink(form.sheetid).id;

				} else {
					this.detailSheetData[idx].linkMenu = false;
					this.delDetailLink = this.findLinkByDetail(form.sheetid).id;
				}
			},
			menuSheetlinkDelete(id, idx){
				this.menuSheetLinkData.splice(idx, 1);
				this.menuSheetLinkData.forEach((a, b)=>{
					this.menuSheetLinkData[b].jobOrder = b+1;
				});
				console.log(this.menuSheetLinkData);
			},
			initialize() {
				let menu = this.selectData;
				
				this.selectData		 = [];
				this.listSheetData	  = [];
				this.detailSheetData	= [];
				this.menuDepth		  = [];
				this.checkList		  = false;
				this.checkDetail		= false;
				this.checkListData	  = {};
				this.checkDetatilData   = {};	  
				this.delDetailLink = '';
				this.delListLink = '';


				this.classifyAuthority();
				this.classifyCompany();
				this.classifyMenu();

				for (let i in menu) {
					this.selectEvent(menu[i].idx, menu[i].id, menu[i].name);
				}
			},
			isNull(a){
				return !common.isNull(a);
			}
		},
		watch: {
		},
	}
</script> 


// WEBPACK FOOTER //
// src/views/Management/Authority/List.vue